"use server"

import type { ValidateResult } from "../shared/types"
import { validateResponsesFromXml } from "./internal/validate"

/**
 * Validates user responses against the QTI XML.
 * This is a server action - call it from the server to keep correct answers secure.
 */
export async function validateResponsesSecure(
	qtiXml: string,
	responses: Record<string, string | string[]>
): Promise<ValidateResult> {
	return validateResponsesFromXml(qtiXml, responses)
}

// Re-export the internal function for direct use
export { validateResponsesFromXml }
